module.exports = __webpack_public_path__ + "img/860238.f57d1f9.svg";